<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 flex justify-between mb-6">
      <span class="text-[#2d82b5] font-semibold">
        Physical Performance Measures for {{ info.fullName }}
      </span>
      <span class="text-sm">
        {{ $t("common.student_id") }}:
        <span class="font-semibold">{{ info.studentCode }}</span>
        <span class="ml-4">
          {{ $t("common.grade") }}:
          <span class="font-semibold">{{ info.grade }}</span>
        </span>
      </span>
    </div>

    <div class="md-layout-item md-size-100">
      <p class="font-medium mb-3">
        {{ $t("smi_sri.detail_about_tests") }}
      </p>

      <md-table class="table-pdf-assessment table-physical">
        <md-table-row>
          <md-table-cell class="diagonal-cross p-0">
            <span class="sup">{{ $t("smi_sri.type") }}</span>
            <span class="sub">{{ $t("smi_sri.test_date") }}</span>
            <div class="line-diagonal"></div>
          </md-table-cell>
          <md-table-cell>{{
            $t("smi_sri.benchpress_in_prounds")
          }}</md-table-cell>
          <md-table-cell>{{
            $t("smi_sri.40_yard_dash_in_seconds")
          }}</md-table-cell>
          <md-table-cell>{{
            $t("smi_sri.vertical_jump_in_inches")
          }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.squat_in_pounds") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.height_in_inches") }}</md-table-cell>
          <md-table-cell>{{ $t("smi_sri.weight_in_pounds") }}</md-table-cell>
          <md-table-cell>{{
            $t("smi_sri.body_mass_index_in_percentage")
          }}</md-table-cell>
        </md-table-row>

        <md-table-row
          class="text-center"
          v-for="(row, index) in dataTable"
          :key="'Physical performance measures' + index"
        >
          <md-table-cell>{{
            convertDateFromServer(row.testDate, "date")
          }}</md-table-cell>
          <md-table-cell>{{ row.benchpressInPounds }}</md-table-cell>
          <md-table-cell>{{ row["40YardDashInSeconds"] }}</md-table-cell>
          <md-table-cell>{{ row.verticalJumpInInches }}</md-table-cell>
          <md-table-cell>{{ row.squatInPounds }}</md-table-cell>
          <md-table-cell>{{ row.heightInInches }}</md-table-cell>
          <md-table-cell>{{ row.weightInPounds }}</md-table-cell>
          <md-table-cell>{{ row.bodyMassIndexInPercentage }}</md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </div>
</template>
<script>
import { convertDateFromServer } from "@/helpers/datetime-helper";

export default {
  name: "export-pdf-physical",
  props: ["info", "dataTable"],
  data() {
    return {
      convertDateFromServer
    };
  }
};
</script>
<style lang="scss">
.table-physical {
  .diagonal-cross {
    position: relative;
    height: 50px;
    width: 150px !important;
    min-width: 150px;
  }

  .line-diagonal {
    position: absolute;
    top: 49%;
    left: -7px;
    width: 160px;
    border-top: 1px solid #e5e7eb;
    transform: rotate(22deg);
  }

  .sup {
    position: absolute;
    top: 10px;
    right: 10px;
  }

  .sub {
    position: absolute;
    bottom: 10px;
    left: 10px;
  }
}
</style>
